import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ElearningWpRemoteState {
  ewrContactId: string | null;
  setEwrContactId: (ewrContactId: string) => void;
  reset: () => void;
}

export const useElearningWpRemoteStore = create<ElearningWpRemoteState>()(
  devtools(
    persist(
      (set) => ({
        ewrContactId: null,
        setEwrContactId: (ewrContactId) => set({ ewrContactId }),
        reset: () => set({ ewrContactId: null })
      }),
      {
        name: 'ewr-store',
        partialize: (state) => ({ ewrContactId: state.ewrContactId })
      }
    ),
    { name: 'EwrStore' }
  )
);
